<script>
    import {HeroForm} from '../store.js';
    import {getContext} from 'svelte';
    import LoadingPage from '../component/loadingPage.svelte';
    import Thanku from '../thankyou_popup/thanku.svelte';
    import {showThankUPopUp} from './store.js';
    const stripe = new Stripe('pk_test_r92ZuCp1EQ56ihyCqVWdc2n5');
    const {url} = getContext('APP');
    const formDetail = Object.fromEntries(new URLSearchParams($url.search));
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
    let amountPaid;
    let paymentId;
    let sheetName = '';
    let sendedData;
    let isDisabled = false;
    let applyFee = '5$';
    let flagCheck = 0;
    let showLoadingPage = false;
    let popUp = {
        heading: null,
        description: null,
    };
    if (HeroForm.get().startup === 'Yes') {
        applyFee = '155$';
    }
    /**
     *
     *
     */
    function getBody() {
        if (formDetail.name === 'VCX' ) {
            sheetName = 'VCx!A1:J1';
            sendedData = [HeroForm.get().email, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().phoneNumber, HeroForm.get().aboutYourSelf,
                'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'investor') {
            sheetName = 'Investors!A1:J1';
            sendedData = [HeroForm.get().email, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().phoneNumber, HeroForm.get().aboutYourSelf,
                'not paid', amountPaid + '$', paymentId];
        } else if (formDetail.name === 'Government') {
            sheetName = 'Government!A1:J1';
            sendedData = [HeroForm.get().email, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().phoneNumber, HeroForm.get().aboutYourSelf,
                'not paid', amountPaid + '$', paymentId];
        } else if (formDetail.name === 'HouseOfCeek') {
            sheetName = 'House of Ceek!A1:T1';
            sendedData = [HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().portfolioURL,
                HeroForm.get().buildingPlan, HeroForm.get().travelBudget, HeroForm.get().buildingWeeks,
                HeroForm.get().hearAbout,
                HeroForm.get().invitedtoProgram, HeroForm.get().ackowledged,
                'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'HeroTraining') {
            sheetName = 'Hero Training!A1:W1';
            sendedData = [
                HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().technicalSkill,
                HeroForm.get().englishAbility,
                HeroForm.get().industry, HeroForm.get().industryOther, HeroForm.get().business, HeroForm.get().visa,
                HeroForm.get().aid, HeroForm.get().referalName, HeroForm.get().hearAbout,
                HeroForm.get().hearAboutOthers, 'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'KanooInnovationHub') {
            sheetName = 'Kanoo Innovation Hub!A1:W1';
            sendedData = [
                HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().technicalSkill,
                HeroForm.get().englishAbility,
                HeroForm.get().industry, HeroForm.get().industryOther, HeroForm.get().business, HeroForm.get().visa,
                HeroForm.get().aid, HeroForm.get().referalName, HeroForm.get().hearAbout,
                HeroForm.get().hearAboutOthers, 'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'FundamentalsOfEntrepreneurship') {
            sheetName = 'Fundamentals of Entrepreneurship!A1:O1';
            sendedData = [
                HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().business,
                HeroForm.get().Startup, 'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'CorporateInnovation') {
            sheetName = 'Corporate Innovation Program!A1:O1';
            sendedData = [
                HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().business,
                HeroForm.get().Startup, 'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'Blockchain') {
            sheetName = 'Blockchain!A1:O1';
            sendedData = [
                HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().business,
                HeroForm.get().Startup, 'not paid', amountPaid + '$', paymentId,
            ];
        } else if (formDetail.name === 'CorporateAccelerator') {
            sheetName = 'Corporate Accelerators!A1:O1';
            sendedData = [
                HeroForm.get().email, HeroForm.get().session, HeroForm.get().name, HeroForm.get().country,
                '\'\ ' + HeroForm.get().countryCode, HeroForm.get().city, HeroForm.get().phoneNumber,
                HeroForm.get().dateOfBirth, HeroForm.get().gender, HeroForm.get().business,
                HeroForm.get().Startup, 'not paid', amountPaid + '$', paymentId,
            ];
        }
    }
    /**
     *
     *
    */
    function displayPopUp() {
        showThankUPopUp.update((n) => n + 1);
    }
    /**
     *
     *
     */
    async function saveInSheet() {
        const functionUrl = 'https://us-central1-draper-university.cloudfunctions.net/updateWorkSheet';
        await fetch(functionUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sheetRange: sheetName,
                data: sendedData,
            }),
        }).then(function(res) {
            if (res.status === 401) {
                showLoadingPage = false;
                popUp = {
                    heading: 'invaild Email!',
                    description: 'Please Try Again with vaild Email',
                };
                displayPopUp();
                isDisabled = false;
                flagCheck = 0;
            } else if (res.status === 200) {
                HeroForm.reset();
                stripe.redirectToCheckout({sessionId: paymentId});
            } else {
                showLoadingPage = false;
                popUp = {
                    heading: 'Error!',
                    description: 'Error from Server please try after some time.',
                };
                displayPopUp();
                isDisabled = false;
                flagCheck = 0;
            }
        });
    }
    /**
     *
     *
     */
    async function paymentFun() {
        isDisabled = true;
        showLoadingPage = true;
        if (flagCheck===0) {
            flagCheck = 1;
            const paymentUrl = 'https://us-central1-draper-university.cloudfunctions.net/payment';
            await fetch(paymentUrl, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: [HeroForm.get().startup],
                }),
            }).then( async function(res) {
                if (res.status === 200) {
                    const sessions = await res.json();
                    amountPaid = sessions.amount;
                    paymentId = sessions.sessionID;
                    getBody();
                    saveInSheet();
                } else {
                    showLoadingPage = false;
                    popUp = {
                        heading: 'Error!',
                        description: 'Error from Server please try after some time.',
                    };
                    displayPopUp();
                    isDisabled = false;
                    flagCheck = 0;
                }
            });
        }
    }
    /**
     *
     *
     */
    function closePayment() {
        if (formDetail.name === 'VCX') {
            location.href='/apply?name=VCX';
        } else if (formDetail.name === 'investor') {
            location.href='/apply?name=investor';
        } else if (formDetail.name === 'Government') {
            location.href='/apply?name=Government';
        } else if (formDetail.name === 'FundamentalsOfEntrepreneurship') {
            location.href='/apply?name=FundamentalsOfEntrepreneurship&FormNo=thirdform';
        } else if (formDetail.name === 'HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=forthform';
        } else if (formDetail.name === 'HouseOfCeek') {
            location.href='/apply?name=HouseOfCeek&FormNo=forthform';
        } else if (formDetail.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=forthform';
        } else if (formDetail.name === 'CorporateInnovation') {
            location.href='/apply?name=CorporateInnovation&FormNo=thirdform';
        } else if (formDetail.name === 'CorporateAccelerator') {
            location.href='/apply?name=CorporateAccelerator&FormNo=thirdform';
        } else if (formDetail.name === 'Blockchain') {
            location.href='/apply?name=Blockchain&FormNo=thirdform';
        }
    }
    
</script> 
{#if showLoadingPage }
<LoadingPage />
{/if}
<Thanku  headingText={popUp.heading}
paraText={popUp.description}/>
<div class="desktop">
    <div class="div_wrraper" on:click={()=>{
        closePayment();
   }} role='presentation'>
        
    </div>
    <div class="main-div">
        <div class="closeBtn"  on:click={()=>{
             closePayment();
        }} role='presentation'>
           <img src="/images/apply/close.svg" alt="" width="100%" height="100%">
        </div>
        <div><p class="heading">APPLICATION FORM</p></div>

        <div><p class="heading2">Application Fee: {applyFee}</p></div>

        <div>
            <p class="text">
                Complete your payment to start your entrepreneurial journey
                with Draper University.
            </p>
        </div>

        <div>
            <p class="text2">*This is no-refundable processing fee.*</p>
        </div>
        <div>
            <button type = "submit"
            class="{isDisabled ? 'button-disabled' : ''}"
            disabled={isDisabled}
                ><p
                    style="font-weight: 500 ; padding: 1vw; color: white; font-size: 1.190vw;"  on:click={() => ( paymentFun())} role='presentation'
                >
                    Pay Now
                </p></button
            >
        </div>
    </div>
</div>

<div class="mobile">
    <div class="div_wrraper-mobile" on:click={()=>{
        closePayment();
   }} role='presentation'>
        
    </div>
    <div class="main-div-mobile">
        <div class="closeBtn" on:click={()=>{
            closePayment();
        }} role='presentation'>
            <img src="/images/apply/close.svg" alt="" width="100%" height="100%">
         </div>
        <div><p class="heading-mobile">APPLICATION FORM</p></div>

        <div><p class="heading2-mobile">Application Fee: {applyFee}</p></div>

        <div>
            <p class="p-mobile">
                Complete your payment to start your entrepreneurial journey
                with Draper University.
            </p>
        </div>

        <div>
            <p class="p2-mobile">*This is no-refundable processing fee.*</p>
        </div>
        <div>
            <button class="button-mobile {isDisabled ? 'button-disabled' : ''}"  type = "submit"
            disabled={isDisabled}
                ><p 
                    style="font-weight: 500; text-align: center;padding: 1.5vw; color: white; font-size: 2.314vw;"  on:click={() => ( paymentFun())} role='presentation'
                >
                    Pay Now
                </p></button
            >
        </div>
    </div>
</div>

<style>
    .div_wrraper {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: #00183861;
        top: 0;
        z-index: 3;
    }
    .main-div {
        position: absolute;
        width: 41.27vw;
        top: 26.852vw;
        padding-bottom: 2vw;
        background: white;
        border-radius: 1.323vw;
        left: 27.307vw;
        z-index: 5;
    }
    .closeBtn{
        position: absolute;
        top: 1.190vw;
        right: 1.455vw;
        width: 0.860vw;
        height: 0.860vw;
    }
    .heading {
        text-align: center;
        margin-top: 1.72vw;
        color: rgba(0, 32, 75, 1);
        font-size: 1.323vw;
        font-weight: 600;
    }
    .heading2 {
        top: 3.836vw;
        margin-left: 15.146vw;
        color: rgba(0, 32, 75, 1);
        font-size: 1.19vw;
        font-weight: 400;
    }
    .text {
        top: 6.746vw;
        margin-left: 2.447vw;
        color: rgba(0, 32, 75, 1);
        font-size: 0.926vw;
        font-weight: 300;
    }
    .text2 {
        top: 8.796vw;
        margin-left: 12.103vw;
        color: rgba(0, 32, 75, 1);
        font-size: 0.926vw;
        font-weight: 300;
    }
    button {
        font-size: 1.058vw;
        margin-top: 2.249vw;
        margin-left: 16.5vw;
        background-color: rgba(60, 116, 192, 1);
        height: 3.638vw;
        width: 9.193vw;
        border-radius: 1.984vw;
        border: none;
    }
    .button-disabled {
        background-color: grey !important;
    }
    .div_wrraper-mobile {
        width: 100vw;
        height: 402vw;
        position: absolute;
        background-color: #00183861;
        top: 0vw;
    }
    .main-div-mobile {
        position: absolute;
        width: 86.389vw;
        top: 202.722vw;
        padding-bottom: 5vw;
        background: white;
        border-radius: 1.323vw;
        left: 10.778vw;
        z-index: 5;
    }

    .heading-mobile {
        text-align: center;
        margin-top: 3.764vw;
        color: rgba(0, 32, 75, 1);
        font-size: 3.056vw;
        font-weight: 600;
    }
    .heading2-mobile {
        top: 4.628vw;
        text-align: center;
        color: rgba(0, 32, 75, 1);
        font-size: 2.5vw;
        font-weight: 400;
    }
    .p-mobile {
        font-size: 1.944vw;
        margin-top: 6.367vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 300;
        text-align: center;
    }
    .p2-mobile {
        margin-top: -0.517vw;
        text-align: center;
        color: rgba(0, 32, 75, 1);
        font-size: 1.944vw;
        font-weight: 300;
    }
    .button-mobile {
        margin-left: 34.722vw;
        margin-top: -0.372vw;
        background-color: rgba(60, 116, 192, 1);
        height: 6.8vw;
        width: 17.217vw;
        border-radius: 4.342vw;
        border: none;
    }

    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .closeBtn{
        position: absolute;
        top: 0.5vw;
        right: 3.612vw;
        width: 1.944vw;
        height: 1.944vw;
    }     
    }
  
</style>
